class Store {
  state = {
    type: 0
  }
}

export const store = new Store()
